import {combineEpics, Epic} from 'redux-observable';
import {from} from 'rxjs';
import {catchError, filter, switchMap, tap} from 'rxjs/operators';
import axios from 'axios';
import {refreshMenuAction, resetMenuModelsAction} from 'appmodule/home/action/MenuAction';
import {toastServerError} from 'module/Error/Toast';
import {selMenuRefreshTS} from 'appmodule/home/selector/MenuSelector';
import moment from 'moment';

let fetching = false

const RefreshMenuEpic: Epic = (action$, state$) => action$.pipe(
	filter(refreshMenuAction.match),
	filter(({payload: {force}}) => !fetching && (force || selMenuRefreshTS(state$.value) < +moment().startOf('day'))),
	switchMap(() => {
			fetching = true
			return from(axios.get("../json/home/menu")).pipe(
				switchMap(response => [resetMenuModelsAction(response.data)]),
				tap(() => fetching = false),
				catchError((err) => {
					toastServerError(err, "Fehler beim Laden der Menüeinträge")
					return [resetMenuModelsAction([])]
				}),
			);
		},
	),
)

export const MenuEpic = combineEpics(RefreshMenuEpic)